import Star from './star.component';
import { useStarRatingCtx } from './starRatingContext';

function StarsList() {
  const { maxValue } = useStarRatingCtx();

  return (
    <div className="star-rating flex">
      {[...Array(maxValue)].map((star, index) => {
        const value = index + 1;

        return <Star key={index} value={value} />;
      })}
    </div>
  );
}

export default StarsList;
